import { Component, OnInit } from '@angular/core';
import {AgRendererComponent, ICellRendererAngularComp} from 'ag-grid-angular';


@Component({
  selector: 'app-boolean-check',
  templateUrl: './boolean-check.component.html',
  styleUrls: ['./boolean-check.component.scss']
})
export class BooleanCheckComponent implements ICellRendererAngularComp {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  /**
   * @description
   * @returns {boolean}
   */
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  /**
   * @name getIcon
   * @description Retornar icono
   */
  getIcon () {
    let color = 'm-btn-warning';
    let ico = 'icofont-question';

    if (String(this.params.value) === 'true' || String(this.params.value) === '1' ) {
      ico = 'icofont-ui-check';
      color = 'm-btn-success';
    } else {
      ico = 'icofont-ui-close';
      color = 'm-btn-danger';
    }
    // if (String(this.params.value) === 'false' || String(this.params.value) <= '0') {

    // }

    return {
      ico: ico,
      color: color
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/boolean-check/boolean-check.component.ts